import Module from '../../utils/modules/Module';

export default class PlayTruePage extends Module {
  constructor (options) {
    super(options)

    this.DOMEl = options.element;

    this.body = document.body;
    this.heroWrapper = this.DOMEl.querySelector(".hero-wrapper");
    this.heroLogo = this.DOMEl.querySelector(".hero-logo");
    this.heroImages = this.DOMEl.querySelectorAll(".hero-images img");
    this.heroTitle = this.DOMEl.querySelector(".hero-title");
    this.heroTitleImages = this.DOMEl.querySelectorAll(".image-part");

    gsap.registerPlugin(ScrollTrigger);
    gsap.delayedCall(0.3, this.init.bind(this));

    this.totalSteps = 2;
    this.currentStep = 0;
    this.stepHeight = window.innerHeight;

    this.isDesktop = window.matchMedia("(min-width: 771px)").matches;

    this.watchResize.bind(this)();
    window.addEventListener('resize', this.watchResize.bind(this));
  }

  watchResize() {
    this.heroTitleImages.forEach((image, index) => {
      const wrapperRect = this.heroWrapper.getBoundingClientRect();
      this.heroWrapper.style.setProperty(`--image-part-${index}-x`, (image.getBoundingClientRect().left - wrapperRect.left) + 'px');
      this.heroWrapper.style.setProperty(`--image-part-${index}-y`, (image.getBoundingClientRect().top - wrapperRect.top) + 'px');
    })

    this.isDesktop = window.matchMedia("(min-width: 771px)").matches;
  }

  init() {
    const _this = this;

    gsap.timeline({
      scrollTrigger: {
        trigger: '.hero-wrapper',
        end: `+=${this.stepHeight * this.totalSteps}`,
        pin: true,
        onUpdate: (self) => {
          if (self.progress >= 0.33 && self.progress < 0.66) {
            this.heroWrapper.dataset.step = '1';
          } else if (self.progress >= 0.66) {
            this.heroWrapper.dataset.step = '2';
          } else {
            this.heroWrapper.dataset.step = '0';
          }
        }
      }
    })

    const bgColors = this.DOMEl.querySelectorAll("[data-bg-color]");

    bgColors.forEach((bgColor, index) => {
      gsap.timeline({
        scrollTrigger: {
          trigger: bgColor,
          onEnter: () => {
            this.body.style.setProperty('--bg-color', bgColor.dataset.bgColor);
          },
          onEnterBack: () => {
            this.body.style.setProperty('--bg-color', bgColor.dataset.bgColor);
          },
          onLeave: () => {
            if(index === bgColors.length - 1) {
              this.body.style.setProperty('--bg-color', '');
            }
          },
          onLeaveBack: () => {
            if(index === 0) {
              this.body.style.setProperty('--bg-color', '');
            }
          }
        }
      })
    })

    const bigTitles = gsap.utils.toArray(".paragraph-title");

    bigTitles.forEach((title) => {
      const words = title.querySelectorAll(".paragraph-title-word");

      if (words[0]) {
        gsap.to(words[0], {
          scrollTrigger: {
            trigger: title,
            start: 'top bottom',
            scrub: true
          },
          xPercent: -10
        })
      }

      if (words[1]) {
        gsap.to(words[1], {
          scrollTrigger: {
            trigger: title,
            start: 'top bottom',
            scrub: true
          },
          xPercent: 10
        })
      }
    })

    const imageReveals = gsap.utils.toArray(".image-reveal");

    imageReveals.forEach((imageReveal) => {
      gsap.to(imageReveal, {
        scrollTrigger: {
          trigger: imageReveal,
          start: 'top 70%',
          onEnter: () => {
            imageReveal.classList.add('active');
          }
        },
      })
    })

    const imagesStacks = gsap.utils.toArray(".paragraph--type--two-texts-images-stack .paragraph-images");

    imagesStacks.forEach((imagesStack) => {

      const images = imagesStack.querySelectorAll("img");
      const imagesLength = images.length;
      const imagesStackHeight = imagesStack.offsetHeight;

      images.forEach((image, index) => {

        if(index === imagesLength - 1) {
          return;
        }

        const imageTl = gsap.timeline({
          scrollTrigger: {
            trigger: imagesStack,
            scrub: true,
            start: () => {
              return `top+=${(index) * (imagesStackHeight / imagesLength)}px top`;
            },
            end: () => {
              return `+=${imagesStackHeight / imagesLength}px`;
            }
          }
        })

        imageTl.to(image, {
          translateY: '-130%',
          ease: 'none'
        })
      })
    });


    if (this.isDesktop) {
      const stepsLists = gsap.utils.toArray(".paragraph--type--steps-list");

      stepsLists.forEach((stepsList) => {
        const images = stepsList.querySelectorAll("img");
        const imagesLength = images.length;
        const stepsListHeight = stepsList.offsetHeight;

        gsap.timeline({
          scrollTrigger: {
            trigger: stepsList,
            onUpdate: (self) => {
              const progress = self.progress;
              const offset = 0.1; // 10% offset
              const activeImages = images.length - 1; // Exclude last image
              const splitSize = (1 - offset) / activeImages;
              stepsList.dataset.currentStep = Math.floor(progress / splitSize);
            }
          }
        });

        images.forEach((image, index) => {

          if(index === imagesLength - 1) {
            return;
          }

          const imageTl = gsap.timeline({
            scrollTrigger: {
              trigger: stepsList,
              scrub: true,
              start: () => {
                return `top+=${(index) * (stepsListHeight / imagesLength)}px top`;
              },
              end: () => {
                return `+=${stepsListHeight / imagesLength}px`;
              }
            }
          })

          imageTl.to(image, {
            translateX: '120%',
            ease: 'none'
          })
        })
      })
    }

    gsap.timeline({
      scrollTrigger: {
        trigger: '#flockr-container',
        start: 'top bottom',
        onEnter: () => {
          _this.loadFlockr();
        }
      }
    })

  }

  async loadFlockr() {
    const response = await fetch('/api/flockr');
    const data = await response.json();

    if(data.posts && data.posts.length > 0) {
      const flockrContainer = this.DOMEl.querySelector('#flockr-container');
      flockrContainer.innerHTML = '';

      data.posts.forEach((post) => {
        flockrContainer.innerHTML += `<li><a href="${post.sourceUrl}" target="_blank" class="flockr-post"><img src="${post.images[0].url}" alt="${post.images[0].altText}" /><p class="screen-reader-only">${post.textPlain}</p></a></li>`;
      })
    }
  }
}
